import * as React from 'react';
import {WrappedFieldProps} from 'redux-form';
import {OptionsElement} from './../../../../Models/ViewManagementModel';

type Props = {
    label: string;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    options: Array<OptionsElement>;
    iconSrc: string;
};

class BooleanIcon extends React.PureComponent<WrappedFieldProps & Props> {
    public handleClick(value) {
        if (this.props.disabled) {
            return null;
        } else {
            this.props.input.onChange(!value);
        }
    }

    public render() {
        const {input, iconSrc} = this.props;
        return (
            <div className={`form-field__message-type ${input.value ? 'form-field__message-type--active' : ''}`}
                 onClick={() => this.handleClick(input.value)}>
                <img src={iconSrc} alt="" width={18}/>
            </div>
        );
    }
}

export default BooleanIcon;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/BooleanIcon.tsx